import React from 'react';
import { useTranslation } from 'react-i18next';
import { SyncOutlined, ExclamationCircleTwoTone, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

import { Info } from './CacheInfo.style';
import Tooltip from 'antd/es/tooltip';
import { variables } from '../../../styles/variables';

interface Props {
  /** informacja czy cache jest aktualizowany */
  synInProgress: WithCache['syncInProgress'];
  /** informacja czy cache jest aktualny */
  isUpToDate: WithCache['isUpToDate'];
  /** informacja czy wystąpił błąd */
  error: WithCache['error'];
}

/**
 * Komponent wyświetlający informację o aktualności cache. Widnieje on w prawym rogu nad tabela.
 *
 */
function CacheInfo(props: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Info>
      {props.error ? (
        <Tooltip title={t('DATA_SYNC_FAIL_DESCRIPTION')}>
          <span>
            <CloseCircleTwoTone twoToneColor='#D9362E' />
            <span>{t('DATA_SYNC_FAIL')}</span>
          </span>
        </Tooltip>
      ) : props.synInProgress ? (
        <>
          <SyncOutlined spin />
          &nbsp;
          <span>{t('DATA_SYNC_IN_PROGRESS')}</span>
        </>
      ) : props.isUpToDate ? (
        <>
          <CheckCircleTwoTone twoToneColor={variables.colorSuccess} />
          <span>{t('DATA_SYNC_UP_TO_DATE')}</span>
        </>
      ) : (
        <>
          <ExclamationCircleTwoTone />
          &nbsp;
          {t('DATA_SYNC_REFRESH_PAGE')}
        </>
      )}
    </Info>
  );
}

export default React.memo(CacheInfo);
